import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function BookingModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <div>
              <h2 className="text-2xl font-heading font-bold text-ayurveda-green-dark">
                Book Your Appointment
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                Schedule your consultation with Kalyan Ayurveda
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              aria-label="Close booking modal"
            >
              <XMarkIcon className="h-6 w-6 text-gray-600" />
            </button>
          </div>

          {/* Booking iframe */}
          <div className="flex-1 overflow-hidden">
            <iframe
              src="https://booking.vedamrita.com/book/kalyaan-ayurveda-hospital"
              className="w-full h-full border-0"
              title="Book Appointment - Kalyan Ayurveda"
              allow="payment"
            />
          </div>

          {/* Footer with alternative contact */}
          <div className="p-4 border-t border-gray-200 bg-ayurveda-green-light">
            <p className="text-sm text-center text-gray-700">
              Having trouble booking? Call us directly at{' '}
              <a href="tel:+919992009696" className="font-semibold text-ayurveda-green-dark hover:underline">
                099920 09696
              </a>
              {' '}or{' '}
              <a 
                href="https://wa.me/919992009696" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-semibold text-green-600 hover:underline"
              >
                WhatsApp us
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
